import { apiPath } from "./GeneralFunc";

const LoginFunc = async (props: { email: string; password: string }) => {
  const dataToSend = {
    email: props.email,
    password: props.password,
  };


  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dataToSend),
  };


  try {
    const response = await fetch(apiPath + "/login", requestOptions);
    if (response == null || !response.ok) {
      return "Error";
    }
    const UserFromDB = await response.text();
    return UserFromDB;
  } catch (error) {
    return "Error";
  }
};

export default LoginFunc;
